import { BaseMutations } from '@/store/base-mutations';
import OrdersInvoicesState from './state';
import { Orders } from '../../../types';

export default class OrdersInvoicesMutations extends BaseMutations<OrdersInvoicesState> {
  TOGGLE_LOADING_ORDERS_INVOICES(toggle: boolean) {
    this.state.orders_invoices_loading = toggle;
  }

  SET_ORDERS_INVOICES(orders_payments: Orders.OrdersInvoiceInfo[]) {
    this.state.orders_invoices_list = orders_payments;
  }

  SET_ORDERS_INVOICES_ORGANIZATIONS(orgs: string[]) {
    this.state.orders_invoices_organizations = orgs;
  }

  SET_ALLOWED_DATES_ORDERS_INVOICES(dates: string[]) {
    this.state.orders_invoices_allowed_dates = dates;
  }

  SET_USERS(users: Orders.UsersFilter[]) {
    this.state.users = users;
  }

  UPD_ORDERS_INVOICES_FILTER_KEY({
    key,
    value,
  }: {
    key: keyof Orders.OrdersInvoicesFilters | string;
    value: unknown;
  }) {
    this.state.orders_invoices_filters[key] = value;
  }

  UPD_ALL_SELECTED_ORDERS_INVOICES(value: boolean) {
    this.state.orders_invoices_list = this.state.orders_invoices_list.map((item: Orders.OrdersInvoiceInfo) => ({
      ...item,
      selected: value,
    }));
  }

  UPD_SELECTED_ORDERS_INVOICES({ item, value }: { item: Orders.OrdersInvoiceInfo, value: boolean }) {
    if (!item) {
      return;
    }

    this.state.orders_invoices_list = this.state.orders_invoices_list.map((order) =>
      (order.id === item.id ? { ...order, selected: value } : order));
  }
}
